"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLoans = getUserLoans;
var firestore_1 = require("firebase/firestore");
var store_1 = require("../../store");
var firebase_1 = require("../../utils/firebase");
function getUserLoans() {
    return __awaiter(this, void 0, void 0, function () {
        var state, authState, firebaseId, firebaseUserId, userData, loansCollectionRef, userDocRef, querySnapshot, loans_1, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    state = store_1.store.getState();
                    authState = state.auth;
                    firebaseId = (_b = (_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
                    // Fall back to Redux state, then localStorage
                    if (!firebaseId) {
                        firebaseId =
                            authState.firebase_user_id || localStorage.getItem("firebase_user_id");
                    }
                    // If not found, check Sky Lifestyle user data
                    if (!firebaseId) {
                        firebaseUserId = localStorage.getItem("sky_user_data");
                        if (firebaseUserId) {
                            try {
                                userData = JSON.parse(firebaseUserId);
                                firebaseId = userData.firebaseId || userData.id;
                            }
                            catch (e) { }
                        }
                    }
                    if (!firebaseId) {
                        return [2 /*return*/, {
                                success: false,
                                message: "User not authenticated with Firebase",
                                content: [],
                            }];
                    }
                    loansCollectionRef = (0, firestore_1.collection)(firebase_1.firestore, "loan_applications");
                    userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", firebaseId);
                    return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.query)(loansCollectionRef, (0, firestore_1.where)("user", "==", userDocRef)))];
                case 1:
                    querySnapshot = _c.sent();
                    loans_1 = [];
                    querySnapshot.forEach(function (doc) {
                        var loanData = doc.data();
                        loans_1.push(__assign({ uid: doc.id }, loanData));
                    });
                    // Sort by date_started (newest first)
                    loans_1.sort(function (a, b) {
                        var _a, _b;
                        var aSeconds = ((_a = a.date_started) === null || _a === void 0 ? void 0 : _a.seconds) || 0;
                        var bSeconds = ((_b = b.date_started) === null || _b === void 0 ? void 0 : _b.seconds) || 0;
                        return bSeconds - aSeconds;
                    });
                    return [2 /*return*/, {
                            success: true,
                            message: "Successfully returned user loans",
                            content: loans_1,
                        }];
                case 2:
                    error_1 = _c.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: [] }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
